<ds-root
  [shouldShowFullscreenLoader]="(isAuthBlocking$ | async) || (isThemeLoading$ | async)"
  [shouldShowRouteLoader]="isRouteLoading$ | async"></ds-root>

<ds-social *ngIf="browserPlatform"></ds-social>
